import type { CSSProperties, FC } from "react";
import { useState } from "react";
// import { Btn } from "@/shared/ui/btn";
import { pricingMock } from "../api/mock";
import type { TBilling } from "../config";
import check from "/assets/images/check.svg";

/**
 * Компонент PricingPlans.
 * Отображает секцию тарифных планов с возможностью переключения между Monthly и Yearly.
 * Содержит анимацию плавного перехода и адаптивную верстку.
 * @returns {ReactNode} JSX-разметка секции с тарифами.
 */
export const PricingPlans: FC = () => {

  const {
    title,
    plans,
    featuresLeft,
    featuresRight,
    // buttonText,
  } = pricingMock;

  const [ billing, setBilling ] = useState<TBilling>("yearly");

  const currentPlan = plans[billing];

  const headingStyles = {
    "--heading-margin-desktop": "2rem",
    "--heading-margin-tablet": "2rem",
    "--heading-margin-mobile": "2rem",
  } as CSSProperties;

  return (
    <section
      id={"pricing"}
      className={"w-full min-h-120 mobile:min-h-15 flex flex-col gap-1 items-center justify-center mobile:max-w-100 mx-auto text-center p-16 mobile:px-6 mobile:py-8 rounded-[2rem] tablet:mt-[-40rem] z-5 translate-y-1/2 mt-[-40rem] mobile:mt-[-29rem] bg-[linear-gradient(135deg,#C6F1F7_0%,#F9BE83_36%,#FF77A2_74%,#C2E9CD_100%)]"}
    >
      <h2 style={headingStyles} className={"text-cherrywood"}>
        {title}
      </h2>

      <div className={"relative w-88 mobile:w-70 h-14 bg-cherrywood/10 rounded-full p-1 mb-10 mobile:mb-0 overflow-hidden mt-6"}>
        {/* Плавающий индикатор */}
        <div
          className={`absolute top-1 left-1 h-[calc(100%-8px)] w-44 mobile:w-34 rounded-full bg-cherrywood transition-transform duration-500 ease-in-out ${
            billing === "monthly" ? "translate-x-44 mobile:translate-x-34" : "translate-x-0"
          }`}
        />
        <div className={"relative z-10 flex justify-between items-center h-full px-3 mobile:px-1 font-medium"}>
          <button
            onClick={() => setBilling("yearly")}
            className={`w-1/2 flex items-center text justify-center gap-2 mobile:gap-1 transition-colors duration-300 ${
              billing === "yearly" ? "text-white" : "text-cherrywood cursor-pointer"
            }`}
          >
            {"Annually"}
            {plans.yearly.discount && (
              <span
                style={plans.yearly.discount.style}
                className={"font-semibold"}
              >
                {plans.yearly.discount.text}
              </span>
            )}
          </button>
          <button
            onClick={() => setBilling("monthly")}
            className={`w-1/2 transition-colors duration-300 text ${
              billing === "monthly" ? "text-white" : "text-cherrywood cursor-pointer"
            }`}
          >
            {"Monthly"}
          </button>
        </div>
      </div>

      {/* === Цена === */}
      <div className={"flex flex-col items-center mb-11 mobile:mb-1 h-22 relative w-full"}>
        <div
          key={billing}
          className={"absolute inset-0 flex gap-3 items-center justify-center transition-all duration-500 ease-[cubic-bezier(0.45,0,0.55,1)] animate-slideIn"}
        >
          <span className={"text-[10rem] mobile:text-[7rem] font-semibold text-cherrywood leading-[100%] tracking-[-0.03em]"}>
            {`$${currentPlan.price}`}
          </span>
          <div className={"flex flex-col self-end mobile:self-center"}>
            <span className={"text-[3rem] mobile:text-[2.5rem] font-semibold text-cherrywood"}>
              {"/month"}
            </span>
            <p className={"text text-cherrywood"}>{currentPlan.label}</p>
          </div>
        </div>
      </div>

      {/* === Фичи === */}
      <div className={"flex gap-4 items-center mb-14 mobile:flex-col mobile:gap-3.5 mobile:mb-6"}>
        <div className={"flex flex-col gap-4.5 items-start flex-start w-79 mobile:w-70 mobile:gap-3.5"}>
          {featuresLeft.map(({ text }, index) => (
            <div key={index} className={"text-start justify-between w-full"}>
              <p className={"flex items-center gap-2 text-cherrywood text"}>
                <img draggable={false} src={check} alt={"check"} width={18} />
                {text}
              </p>
            </div>
          ))}
        </div>
        <div className={"flex flex-col gap-4.5 items-start flex-start w-79 mobile:w-70 mobile:gap-3.5"}>
          {featuresRight.map(({ text }, index) => (
            <div key={index} className={"text-start justify-between w-full"}>
              <p className={"flex items-center gap-2 text-cherrywood text"}>
                <img draggable={false} src={check} alt={"check"} width={18} />
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* === Кнопка === */}
      {/* <div className={"relative rounded-full mobile:w-full shadow-[0_8px_32px_rgba(255,119,162,0.45)]"}>
        <Btn typeStyle={"secondary"}>{buttonText}</Btn>
      </div> */}
    </section>
  );
};
